import React from "react";
import classes from "./Footer.module.css";
import { BsGithub } from "react-icons/bs";
import { GrDocumentPdf } from "react-icons/gr";

function Footer() {
  const buttons = [
    {
      title: "Github",
      link: "https://github.com/gitmshdl",
      badge: <BsGithub size="3rem" />,
    },
    {
      title: "CV",
      link: "https://drive.google.com/file/d/1f_4rH82UlHM-5NH34aakWV2ut7Ib9f9x/view?usp=sharing",
      badge: <GrDocumentPdf size="3rem" />,
    },
  ];
  return (
    <div className={classes.container}>
      {buttons.map((button, index) => (
        <a
          key={index}
          href={button.link}
          target="_blank"
          rel="noopener noreferrer"
          className={
            "ani_bounceIn aniUtil_onMouse aniUtil_active aniUtil_onMouseRepeat"
          }
        >
          {button.badge}
          <div className="text-center">{button.title}</div>
        </a>
      ))}
    </div>
  );
}

export default Footer;
